import * as React from 'react';
import dateGenerateConfig from '../utils/momentGenerator';
import { TimeValidator } from '../utils/timeUtils';
var TimePickerContextContext = /*#__PURE__*/React.createContext({
  value: new Date(),
  valueDispatch: function valueDispatch() {},
  momentUtils: dateGenerateConfig("", ""),
  timeValidator: new TimeValidator(function () {})
});
export default TimePickerContextContext;